import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Pagination from '../pagination';
import { StockAction } from '../../store/actions';

class List extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    getStocks: PropTypes.func,
    location: PropTypes.object,
    stocks: PropTypes.object,
  };

  componentDidMount() {
    this.props.getStocks(
      Object.fromEntries(new URLSearchParams(this.props.location.search)),
    );
  }

  onSearch(event) {
    const {
      target: { value },
    } = event;
    this.props.getStocks({ query: value });
  }

  render() {
    const {
      authHasOffice = false,
      getStocks = () => {},
      location = {},
      stocks: { data: stocks = [], links = [] } = {},
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Stock</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getStocks}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '150px' }}
                >
                  <input
                    className="form-control"
                    onChange={this.onSearch.bind(this)}
                    placeholder="Search"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div className="card-body p-0 table-responsive">
              {stocks?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {stocks?.length > 0 && (
                <table className="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      {!authHasOffice && <th>Office</th>}
                      <th>ID</th>
                      <th>Purchased At</th>
                      <th>Chalan Number</th>
                      <th>Model</th>
                      <th>Chassis Number</th>
                      <th>Engine Number</th>
                      <th>Key Number</th>
                      <th>Color</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stocks?.map?.(row => (
                      <tr key={row.id}>
                        {!authHasOffice && <td>{row.office?.name}</td>}
                        <td>{row.id}</td>
                        <td>{row.purchased_at}</td>
                        <td>{row.chalan_number}</td>
                        <td>{row.vehicle?.model}</td>
                        <td>{row.chassis_number}</td>
                        <td>{row.engine_number}</td>
                        <td>{row.key_number}</td>
                        <td>{row.color?.name}</td>
                        <td>{row.price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  stocks: state?.stock?.list,
});

const mapDispatchToProps = dispatch => ({
  getStocks: params => dispatch(StockAction.getStocks(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
